import ChakraProvider from "@pathwright/ux/src/components/chakra/ChakraProvider"
import { usePathwrightContext } from "../pathwright/PathwrightContext"

const ChakraThemeProvider = ({ children, ...props }) => {
  const { school } = usePathwrightContext()

  return (
    <ChakraProvider {...props} brandColorPalette={school.theme?.color_palette}>
      {children}
    </ChakraProvider>
  )
}

export default ChakraThemeProvider
